import React from 'react';
import CardMedia from '@material-ui/core/CardMedia';
import {bool} from 'prop-types';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './assets/plutotv-logo-min.svg'... Remove this comment to see the full error message
import logoMin from './assets/plutotv-logo-min.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './assets/plutotv-logo.svg' or ... Remove this comment to see the full error message
import logo from './assets/plutotv-logo.svg';

AppSidebarLogo.propTypes = {
    isOpen: bool.isRequired,
};

export default function AppSidebarLogo({isOpen}:any) {
    if (isOpen) {
        return (
            <CardMedia
                image={logo}
                className="root__drawer__inner__logo root__drawer__inner__logo-big"
            />
        );
    }
    
    return (
        <CardMedia
            image={logoMin}
            className="root__drawer__inner__logo root__drawer__inner__logo-small"
        />
    );
}
